"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copy = exports.share = exports.animateY = exports.toggleAttr = exports.domReady = void 0;
var domReady = function (callback) {
    return document.addEventListener('DOMContentLoaded', function (event) { return callback(event); }, { once: true });
};
exports.domReady = domReady;
var toggleAttr = function (element, attr, value) {
    return element.setAttribute(attr, element.getAttribute(attr) === value[0] ? value[1] : value[0]);
};
exports.toggleAttr = toggleAttr;
var animateY = function (element, options) {
    var _a, _b, _c;
    var offsetY = options.offsetY ? options.offsetY : 0;
    (_a = options.start) !== null && _a !== void 0 ? _a : (options.start = new Date().getTime());
    (_b = options.maxheight) !== null && _b !== void 0 ? _b : (options.maxheight = element.scrollHeight);
    (_c = options.state) !== null && _c !== void 0 ? _c : (options.state = (element.scrollHeight - offsetY) === element.offsetHeight);
    var runtime = new Date().getTime() - options.start, progress = runtime / options.duration, currHeight = options.maxheight * Math.min(progress, 1), direction = options.state
        ? (options.maxheight - offsetY) - currHeight
        : currHeight - offsetY;
    element.style.height = direction.toFixed(2) + "px";
    if (runtime < options.duration) {
        requestAnimationFrame(function () { return exports.animateY(element, options); });
    }
};
exports.animateY = animateY;
var fallbackCopyTextToClipboard = function (text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    var succeeded = false;
    try {
        succeeded = document.execCommand('copy');
    }
    catch (_a) {
        //
    }
    document.body.removeChild(textArea);
    return succeeded;
};
var share = function (event) {
    event.preventDefault();
    var title = event.target.title, href = event.target.href;
    if (!navigator.share && fallbackCopyTextToClipboard(href)) {
        return;
    }
    navigator.share({
        title: title,
        text: '',
        url: href
    })
        .then(function () { return console.log('Success'); })
        .catch(function (err) { return console.error(err); });
};
exports.share = share;
var copy = function (event) {
    event.preventDefault();
    try {
        var href = event.currentTarget.href;
        if (!navigator.clipboard && fallbackCopyTextToClipboard(href)) {
            return;
        }
        else if (navigator.clipboard) {
            navigator.clipboard.writeText(href);
            return;
        }
    }
    catch (_a) {
        //
    }
};
exports.copy = copy;
